/**
 * Resolves the Dex connector to pre-select on login, or `undefined` when none is
 * configured — in which case login behaviour is identical to before this feature
 * (no `connector_id` is sent and Dex behaves as it does today).
 *
 * Precedence: a `connector_id` URL parameter (used for admin links) wins over the
 * configured default (`VITE_DEX_CONNECTOR_ID`). An empty value means "not configured":
 * `env.sh` substitutes an unset variable to empty at container start, the same way the
 * other runtime env vars are handled.
 */
export function resolveConnectorId(
  search: string,
  envValue: string | undefined
): string | undefined {
  const fromUrl = new URLSearchParams(search).get('connector_id');
  const candidate = fromUrl ?? envValue;
  if (!candidate) return undefined;
  return candidate;
}
